import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useModalData } from 'hooks/index'
// components
import { Scrollbar } from 'components/UI'
import Header from 'components/UI/Modal/Header'
import DrawerModal from 'components/UI/Drawer'
import NewUserForm from './CreateUserForm'
// constants
import { Modals } from 'constants/modals'

const Wrapper = styled(Scrollbar)`
  overflow: auto;
  padding: 20px;
  width: ${({ width }) => (width ? width : '600px')};
  position: relative;
`

const NewUserModal = () => {
  const {
    hideModal,
    modalData: { isOpen, width }
  } = useModalData({ modalType: Modals.NEW_USER_MODAL })

  return (
    <DrawerModal isOpen={isOpen} width={width} hideModal={hideModal}>
      <Header handleClearClick={hideModal}>Create User</Header>
      <Wrapper>
        <NewUserForm hideModal={hideModal} />
      </Wrapper>
    </DrawerModal>
  )
}

export default NewUserModal
